import React from 'react';
import { Button } from '@/components/ui/button';
import Spinner from '@/components/ui/Spinner';

interface InstitutionActionsBarProps {
  onRefresh?: () => Promise<void> | void;
  onDisconnectClick?: () => void;
  isRefreshing: boolean;
  isInstitutionBusy?: boolean;
  isDisconnecting: boolean;
}

export default function InstitutionActionsBar({
  onRefresh,
  onDisconnectClick,
  isRefreshing,
  isInstitutionBusy,
  isDisconnecting,
}: InstitutionActionsBarProps) {
  return (
    <div className="px-4 py-1.5 bg-gray-50/30 border-b border-gray-100">
      <div className="flex gap-2 justify-end">
        {onRefresh && (
          <Button
            variant="outline"
            size="sm"
            disabled={isRefreshing || !!isInstitutionBusy}
            onClick={async () => {
              if (isRefreshing) return;
              await onRefresh();
            }}
            className="gap-2 text-blue-600 border-blue-200 hover:bg-blue-50 hover:text-blue-700"
          >
            {isRefreshing ? (
              <Spinner size="sm" ariaLabel="Refreshing" />
            ) : null}
            {isRefreshing ? 'Refreshing...' : 'Refresh'}
          </Button>
        )}
        {onDisconnectClick && (
          <Button
            variant="outline"
            size="sm"
            onClick={onDisconnectClick}
            disabled={isDisconnecting}
            className="gap-2 text-destructive border-destructive/30 hover:bg-destructive/10 hover:text-destructive"
          >
            {isDisconnecting ? (
              <Spinner size="sm" ariaLabel="Disconnecting" />
            ) : null}
            {isDisconnecting ? 'Disconnecting…' : 'Disconnect'}
          </Button>
        )}
      </div>
    </div>
  );
}
